"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _actions = require("../notification/actions");
var _selectors = require("./selectors");
var _middlewares = require("../network/middlewares");
var _constants = require("../app/constants");
var _actions2 = require("./actions");
var _constants2 = require("./constants");
var _types2 = require("../websocket/types");
var _callbacks = _interopRequireDefault(require("../../callbacks"));
var _config = _interopRequireDefault(require("../../config"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _logger = _interopRequireDefault(require("../../utils/logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _logger.default('saga:call');
function deleteAccount(_ref) {
  var {
    _account
  } = _ref;
  return function* () {
    try {
      logger.log('deleteAccount', {
        _account
      });
      yield (0, _effects.call)(_apis.$deleteAccount, _account);
      yield (0, _effects.put)((0, _actions2.setSIPAccount)({}));
      _callbacks.default.get('analyticsLogEvent')('call_account_delete');
      yield (0, _effects.put)((0, _actions.addNotification)({
        title: 'sip.settings.accountDeleted'
      }));
    } catch (e) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        error: e,
        referenceError: 'SIP8',
        title: 'default.error'
      }));
    }
  }();
}
function* postAccount(action) {
  try {
    logger.log('postAccount', {
      action
    });
    var {
      prefix
    } = action.account;
    if (!prefix) {
      delete action.account.prefix;
    }
    var account = action.account;
    Object.keys(account).forEach(el => {
      if (account[el] === '') delete account[el];
    });
    var {
      data
    } = yield (0, _effects.call)(_apis.$postAccount, account);
    yield (0, _effects.put)((0, _actions2.setSIPAccount)(_objectSpread(_objectSpread(_objectSpread({}, action.account), data), {}, {
      status: _constants2.SIP_STATUS.PENDING,
      hasSettingsLoaded: true
    })));
    _callbacks.default.get('analyticsLogEvent')('call_account_post');
  } catch (e) {
    var _e$response, _e$response2;
    if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 403) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        error: e,
        title: 'sip.error.accountAlreadyCreated'
      }));
      yield (0, _effects.call)(fetchSIPAccounts);
    } else if ((e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 409) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        error: e,
        title: 'sip.error.accountAlreadyDeclared'
      }));
      yield (0, _effects.call)(fetchSIPAccounts);
    } else {
      yield (0, _effects.put)((0, _actions.addNotification)({
        error: e,
        referenceError: 'SIP1',
        title: 'default.error'
      }));
    }
  }
}
function* putAccount(action) {
  try {
    var currentSIPAccount = yield (0, _effects.select)(_selectors.getSIPAccount);
    var SIPAccountId = currentSIPAccount === null || currentSIPAccount === void 0 ? void 0 : currentSIPAccount.id;
    logger.log('putAccount', {
      action,
      SIPAccountId
    });
    if (!SIPAccountId) throw new Error('no SIP account');
    var {
      prefix
    } = action.account;
    if (!prefix) {
      delete action.account.prefix;
    }
    yield (0, _effects.put)((0, _actions2.setSIPAccount)(_objectSpread(_objectSpread({}, currentSIPAccount), {}, {
      status: _constants2.SIP_STATUS.PENDING,
      sipData: {}
    })));
    var account = action.account;
    Object.keys(account).forEach(el => {
      if (account[el] === '') delete account[el];
    });
    yield (0, _effects.call)(_apis.$putAccount, SIPAccountId, account);
    yield (0, _effects.put)((0, _actions2.setSIPAccount)(_objectSpread(_objectSpread(_objectSpread({}, currentSIPAccount), action.account), {}, {
      sipData: {},
      status: _constants2.SIP_STATUS.PENDING,
      hasSettingsLoaded: true
    })));
    _callbacks.default.get('analyticsLogEvent')('call_account_put');
  } catch (e) {
    var _e$response3;
    if ((e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.status) === 409) {
      yield (0, _effects.put)((0, _actions.addNotification)({
        error: e,
        title: 'sip.error.accountAlreadyDeclared'
      }));
      yield (0, _effects.call)(fetchSIPAccounts);
    } else {
      yield (0, _effects.put)((0, _actions.addNotification)({
        error: e,
        referenceError: 'SIP7',
        title: 'default.error'
      }));
    }
  }
}
function checkSIPAccount(_ref2) {
  var {
    type
  } = _ref2;
  return function* () {
    if (type === _types2.WS_CONNECT && !_config.default.sipAccount.fetchOnWsReload) {
      return;
    }
    var accounts = yield (0, _effects.call)(getAccounts, {});
    var currentSIPAccount = yield (0, _effects.select)(_selectors.getSIPAccount);
    if (!(accounts !== null && accounts !== void 0 && accounts.length)) {
      // remove if exists
      if (!currentSIPAccount || currentSIPAccount.id) yield (0, _effects.put)((0, _actions2.setSIPAccount)({}));
      return null;
    }
    var [account] = accounts;
    if ((account === null || account === void 0 ? void 0 : account.status) === _constants2.SIP_STATUS.NOT_REGISTERED) {
      var _account$sipData;
      var reason;
      if (account !== null && account !== void 0 && (_account$sipData = account.sipData) !== null && _account$sipData !== void 0 && _account$sipData.reason) {
        var _account$sipData2;
        reason = "\n(".concat(account === null || account === void 0 || (_account$sipData2 = account.sipData) === null || _account$sipData2 === void 0 || (_account$sipData2 = _account$sipData2.reason) === null || _account$sipData2 === void 0 ? void 0 : _account$sipData2.trim(), ")");
      }
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: "".concat(_i18n.default.translate('sip.error.notRegistered')).concat(reason || '')
      }));
    }
    if ((currentSIPAccount === null || currentSIPAccount === void 0 ? void 0 : currentSIPAccount.updatedAt) !== (account === null || account === void 0 ? void 0 : account.updatedAt)) {
      // TODO: Remove later the storage
      var prefix = yield _callbacks.default.get('asyncStorageGetItem')('SIPPrefix');
      yield (0, _effects.put)((0, _actions2.setSIPAccount)(_objectSpread(_objectSpread({
        prefix
      }, account), {}, {
        hasAdvancedSettings: account.hasAdvancedSettings || !!prefix
      })));
    }
  }();
}
function* fetchSIPAccounts() {
  logger.log('fetchSIPAccounts');
  var accounts = yield (0, _effects.call)(getAccounts, {
    detailled: true
  });
  var currentSIPAccount = yield (0, _effects.select)(_selectors.getSIPAccount);
  if (!accounts || !accounts.length) {
    // remove if exists
    if (!currentSIPAccount || currentSIPAccount.id) yield (0, _effects.put)((0, _actions2.setSIPAccount)({}));
    return null;
  }
  var [account] = accounts;
  if ((currentSIPAccount === null || currentSIPAccount === void 0 ? void 0 : currentSIPAccount.updatedAt) !== (account === null || account === void 0 ? void 0 : account.updatedAt) || !(currentSIPAccount !== null && currentSIPAccount !== void 0 && currentSIPAccount.server)) {
    var prefix = yield _callbacks.default.get('asyncStorageGetItem')('SIPPrefix');
    yield (0, _effects.put)((0, _actions2.setSIPAccount)(_objectSpread(_objectSpread({
      prefix
    }, account), {}, {
      hasAdvancedSettings: account.hasAdvancedSettings || !!prefix
    })));
  }
}
function registrationLogic(_ref3) {
  var {
    payload
  } = _ref3;
  return function* () {
    logger.log('registrationLogic', {
      payload
    });
    // TODO: Remove later the storage
    var prefix = yield _callbacks.default.get('asyncStorageGetItem')('SIPPrefix');
    var currentSIPAccount = yield (0, _effects.select)(_selectors.getSIPAccount);
    delete payload._user;
    delete payload.userUri;
    delete payload.instanceId;
    yield (0, _effects.put)((0, _actions2.setSIPAccount)(_objectSpread(_objectSpread({
      prefix
    }, currentSIPAccount || {}), payload)));
    if (payload.status === _constants2.SIP_STATUS.NOT_REGISTERED) {
      var _payload$sipData;
      var reason;
      if (payload !== null && payload !== void 0 && (_payload$sipData = payload.sipData) !== null && _payload$sipData !== void 0 && _payload$sipData.reason) {
        var _payload$sipData2;
        reason = "\n(".concat(payload === null || payload === void 0 || (_payload$sipData2 = payload.sipData) === null || _payload$sipData2 === void 0 || (_payload$sipData2 = _payload$sipData2.reason) === null || _payload$sipData2 === void 0 ? void 0 : _payload$sipData2.trim(), ")");
      }
      yield (0, _effects.delay)(2000);
      yield (0, _effects.put)((0, _actions.addNotification)({
        message: "".concat(_i18n.default.translate('sip.error.notRegistered')).concat(reason || '')
      }));
    }
  }();
}
function getAccounts(_ref4) {
  var {
    detailled
  } = _ref4;
  return function* () {
    try {
      var _accounts$;
      var {
        data: accounts
      } = yield (0, _effects.call)(_apis.$getAccounts);
      var accountId = accounts === null || accounts === void 0 || (_accounts$ = accounts[0]) === null || _accounts$ === void 0 ? void 0 : _accounts$.id;
      logger.log('get accounts', {
        accountId
      });
      if (accountId) {
        if (detailled) {
          var {
            data
          } = yield (0, _effects.call)(_apis.$getAccount, accountId);
          logger.log('get account', {
            accountId,
            data
          });
          accounts[0] = _objectSpread(_objectSpread({}, accounts[0]), {}, {
            domainServer: data.domainServer,
            outboundProxyIpaddr: data.outboundProxyIpaddr,
            outboundProxyPort: data.outboundProxyPort,
            prefix: data.prefix,
            server: data.server,
            serverPort: data.serverPort,
            username: data.username,
            hasSettingsLoaded: true
          });
        }

        // clear useless data
        if (accounts[0].serverPort === _constants2.SIP_DEFAULT_PORT) {
          delete accounts[0].serverPort;
        }
        if (accounts[0].domainServer && accounts[0].server === accounts[0].domainServer) {
          delete accounts[0].domainServer;
        }
        // add a flag to display or not advanced settings
        if (accounts[0].outboundProxyIpaddr || accounts[0].outboundProxyPort || accounts[0].serverPort || accounts[0].domainServer || accounts[0].prefix) {
          accounts[0].hasAdvancedSettings = true;
        }
      }
      return accounts;
    } catch (e) {
      if (!(0, _middlewares.isNetworkError)(e)) {
        logger.log('get accounts error', e, e.response);
        yield (0, _effects.put)((0, _actions.addNotification)({
          error: e,
          referenceError: 'SIP2',
          title: 'default.error'
        }));
      }
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)(types.REQUEST_DELETE_ACCOUNT, deleteAccount), (0, _sagas.takeLatest)(types.REQUEST_POST_ACCOUNT, postAccount), (0, _sagas.takeLatest)(types.REQUEST_PUT_ACCOUNT, putAccount), (0, _sagas.throttle)(_constants.sagasTiming, [_types2.WS_CONNECT, types.CHECK_SIP_ACCOUNT], checkSIPAccount), (0, _sagas.takeLatest)(types.FETCH_SIP_ACCOUNTS, fetchSIPAccounts), (0, _sagas.takeLatest)(types.WS_SIP_ACCOUNT_REGISTRATION, registrationLogic)]);
}
module.exports = exports.default;